import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReplaySubject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Constants } from 'src/app/constants';
import { HomeService } from 'src/app/service/home.service';

@Component({
  selector: 'app-run-report',
  templateUrl: './run-report.component.html',
  styleUrls: ['./run-report.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None 
})
export class RunReportComponent implements OnInit {
  successmsg;
  errormsg: string;
  heading: string;
  selected_period_id: any
  selectedDomiciles
  selectedResonIds: any
  runPeriodDropDown: any;
  runDomicileDropDown: any;
  runReasonDropDown: any;
  response: any;
  gotResponse: boolean = false;
  domicileFilterCtrl: FormControl = new FormControl();
  filteredDomiciles: ReplaySubject<any[]> = new ReplaySubject(1);
  reasonFilterCtrl: FormControl = new FormControl();
  filteredReasons: ReplaySubject<any[]> = new ReplaySubject(1);
  periodFilterCtrl: FormControl = new FormControl();
  filteredPeriods: ReplaySubject<any[]> = new ReplaySubject(1);

  constructor(public dialogRef: MatDialogRef<RunReportComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any, private readonly constants: Constants,
    private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly homeService: HomeService,) { }

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    console.info(this.dataStore.userId)
    this.runPeriodDropDown = this.dataStore.runPeriodDropDown;
    this.runDomicileDropDown = this.dataStore.runDomicileDropDown;
    this.runReasonDropDown = this.dataStore.runReasonDropDown;

   // Load filtered options safely
   this.filteredDomiciles.next([...this.runDomicileDropDown]);
   this.filteredReasons.next([...this.runReasonDropDown]);
   this.filteredPeriods.next([...this.runPeriodDropDown]);


    this.periodFilterCtrl.valueChanges
      .pipe(
        startWith(''),
        map(search => search ? this.filterPeriods(search) : this.runPeriodDropDown.slice())
      )
      .subscribe(filtered => {
        this.filteredPeriods.next(filtered);
      });

    this.reasonFilterCtrl.valueChanges
      .pipe(
        startWith(''),
        map(search => search ? this.filterReasons(search) : this.runReasonDropDown.slice())
      )
      .subscribe(filtered => {
        this.filteredReasons.next(filtered);
      });

    // Subscribe to search field changes
    this.domicileFilterCtrl.valueChanges
      .pipe(
        startWith(''),
        map(search => search ? this.filterDomiciles(search) : [...this.runDomicileDropDown])
      )
      .subscribe(filtered => {
        this.filteredDomiciles.next(filtered);
      });
  }

  private filterDomiciles(search: string): any[] {
    const lowerSearch = search.toLowerCase();
    return this.runDomicileDropDown.filter(option =>
      option.label.toLowerCase().includes(lowerSearch));
  }

  private filterReasons(search: string): any[] {
    const lowerSearch = search.toLowerCase();
    return this.runReasonDropDown.filter(option =>
      option.label.toLowerCase().includes(lowerSearch));
  }

  private filterPeriods(search: string): any[] {
    const lowerSearch = search.toLowerCase();
    return this.runPeriodDropDown.filter(option =>
      option.label.toLowerCase().includes(lowerSearch));
  }
  


  public saveClick(): void {

    this.errormsg = ""
    if (this.isValueOk(this.selectedResonIds)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.selected_period_id)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.selectedDomiciles)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.dataStore.userId)) {
      this.showError("userId error");
    } else {
      this.APICall();
    }

  }
  APICall() {
    this.errormsg = ""
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    const logisticsPoint = [];
    this.selectedDomiciles.forEach(e => {
      logisticsPoint.push(e.label)
    })
    const postObject = {
      period: this.selected_period_id.label,
      logisticsPoint: logisticsPoint,
      reasonCodes: this.selectedResonIds.label,
      userId: this.dataStore.userId
    }
    this.homeService.getDailyCubeoutKPIReport(postObject).subscribe(
      response => {
        console.info(response)
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        if (response == "Successfully completed Report generation") { // NOSONAR
          this.dialogRef.close({
            event: "SaveEvent",
            data: "Success"
          });
        } else {
          if (response != "") { // NOSONAR
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          }
          this.showError(response)
        }
        this.gotResponse = true;
      }, error => {
        console.info(error)
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.showError(this.constants.APIErrorMessage);
        this.gotResponse = true;
      }
    )

    setTimeout(() => {
      if (!this.gotResponse) {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.dialogRef.close({
          event: "SaveEvent",
          data: "Success"
        });
        console.info("report Response Timeout")
        this.gotResponse = false;

      }
    }, 10000);

  }

  showError(message) {
    this.errormsg = message;
    setTimeout(() => {
      this.errormsg = ""
    }, this.constants.notificationMessageTime);
  }

  isValueOk(param: any): boolean {
    if (param == undefined || param == null || param == "") // NOSONAR
    {
      return true;
    }
    return false;
  }

  onNoClick(): void {
    this.dialogRef.close({
      event: 'NoEvent'
    });
  }
  close(): void {
    this.dialogRef.close(
      { event: 'CloseEvent' }
    );
  }

  isAllSelected(): boolean {
    return this.selectedDomiciles?.length == this.runDomicileDropDown?.length; // NOSONAR
  }
  
  isIndeterminate(): boolean {
  return this.selectedDomiciles?.length > 0 &&
         this.selectedDomiciles?.length < this.runDomicileDropDown?.length;
}
  
  toggleSelectAll(event: any): void {
    if (event.checked) {
      this.selectedDomiciles = [...this.runDomicileDropDown];
    } else {
      this.selectedDomiciles = [];
    }
  }

}
